import React, {useState} from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { Users, Toolbar } from './components';
import { getProfilesDetailsAPIReq } from '../../utils/requests'
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const getProfilesDetails = async (isLoading, setIsLoading, hashedIDs) => {
  if (isLoading){
    return getProfilesDetailsAPIReq(hashedIDs).then((res) => {
      if (res) {
        users = res;
        setIsLoading(false);

      } else {
        alert('error occurred!')
      }
    })
  }
}

let users = [];

export const ViewProfiles = props => {
  const { className, match, ...rest } = props;
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(true); // integer state
  const [open, setOpen] = React.useState(false);
  let usersList = props.location.usersList;
  const handleError = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  }

  getProfilesDetails(isLoading, setIsLoading, props.location.usersList);
  return (
    <div>
      {isLoading?
        <div className={classes.root}>
          <CircularProgress disableShrink />
        </div>
        :
        <div className={classes.root}>
          <Grid
            container
            spacing={4}
          >
            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
              <Toolbar users={users} />
            </Grid>
              <Users usersList={users} />
          </Grid>
          <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity="error">
              An error has occurred
            </Alert>
          </Snackbar>
        </div>
      }
    </div>
  );
};

export default ViewProfiles;
